import { Subject } from "@carnegie-learning/cure-types";
import { Action, createReducer, on } from "@ngrx/store";
import * as subjectActions from "../actions/active-subjects.action";

export interface ActiveSubjectsState {
    entities: Map<string, Subject>;
    loading: boolean;
    loaded: boolean;
}

export const initialState: ActiveSubjectsState = {
    entities: new Map<string, Subject>(),
    loading: false,
    loaded: false
};

const subjectReducer = createReducer(
    initialState,
    on(subjectActions.LoadActiveSubjects, state => {
        return {
            ...state,
            loading: true,
            loaded: false
        };
    }),
    on(subjectActions.LoadActiveSubjectsFail, state => {
        return {
            ...state,
            loading: false,
            loaded: false
        };
    }),
    on(subjectActions.LoadActiveSubjectsSuccess, (state, { payload }) => {
        const activeSubjects = payload.data;
        const entities = new Map<string, Subject>();
        activeSubjects.forEach(activeSubject => {
            entities.set(activeSubject.subjectId, activeSubject);
        });
        return {
            ...state,
            loading: false,
            loaded: true,
            entities
        };
    })
);

export function reducer(state: ActiveSubjectsState | undefined, action: Action) {
    return subjectReducer(state, action);
}

export const getActiveSubjectsEntities = (state: ActiveSubjectsState) =>
    state.entities;
export const getActiveSubjectsLoading = (state: ActiveSubjectsState) =>
    state.loading;
export const getActiveSubjectsLoaded = (state: ActiveSubjectsState) =>
    state.loaded;
